import { AbstractView } from "../view/AbstractView";
/**
 * AbstractControl.ts
 *
 * Automatically calls `run` on the constructor.
 *
 * Does not have a model or factory.
 */
export class AbstractControl extends AbstractView {
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.run();
    }
    callHandler(handler, args) {
        if (handler) {
            handler.call(args);
        }
    }
}
//# sourceMappingURL=AbstractControl.js.map